angular.module('impactx.MenuDirectives').controller('DeactivateProductViewCtrl', [
    '$scope',
    '$context',
    'TranslationService',
    'ProductViewService',
    'ToastService',
    '$redirect',
    'dataGen',
    DeactivateProductViewCtrl]);

function DeactivateProductViewCtrl($scope, $context, TranslationService, ProductViewService, ToastService, $redirect, dataGen) {
    let self = this;
    self.showDeactivationButton = false;

    $scope.$watch(function() {
        return $context.hasActiveProductView.value
    }, function(newValue) {
        self.showDeactivationButton = newValue;
        self.deactivateProductView = TranslationService.get('deactivateProductView');
    });

    self.deactivateCurrentProductView = function() {
        var previousProductViewId = $context.hasActiveProductView.id;

        ProductViewService.deactivateActiveProductView().then(function(data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                ToastService.openStandardToast(data.trns.vcatDeactivated);
                $redirect.redirectTo(null, "/productviewlist");
            });
        });
    };
}